import { Component, Input } from '@angular/core';

export enum QUALIVIS_VMS {
    pa = 'Qualivis PA', // 186,
    ks_mo_epa = 'Qualivis KS/MO EPA', // 2427,
    ks_mo_pa = 'Qualivis KS/MO PA', //2470,
    locum_tenens = 'Qualivis Locum Tenens', // 1772,
    locum_tenens_msp = 'Qualivis Locum Tenens MSP', // 1773,
    direct = 'Qualivis Direct', // 2170,
    spartanburg_non_clinical_msp = 'Qualivis Spartanburg Non-clinical MSP', // 2445,
    washington_enhanced_pa = 'Qualivis Washington Enhanced PA', // 2347,
    washington_pa = 'Qualivis Washington PA', //553,
    louisiana_pa = 'Qualivis Louisiana PA' // 2349
}

/**
 * This class displays the Job rating system: ♥♥✶, ♥♥,♥✶,...
 */
@Component({
    selector: 'nova-job-rating',
    standalone: true,
    imports: [],
    template: `
        @switch (dataItem.ratingId) {
            @case (0) {
                <img
                    src="assets/images/orange_star.png"
                    class="rating-img"
                    alt="Important job, contract breaker, backfill, etc"
                    title="Important job, contract breaker, backfill, etc" />
            }
            @case (2) {
                <img
                    src="assets/images/orange_star.png"
                    class="rating-img"
                    alt="Important job, contract breaker, backfill, etc"
                    title="Important job, contract breaker, backfill, etc" />
            }
            @case (4) {
                <img
                    src="assets/images/orange_star.png"
                    class="rating-img"
                    alt="Important job, contract breaker, backfill, etc"
                    title="Important job, contract breaker, backfill, etc" />
            }
            @case (5) {
                <img
                    src="assets/images/smiley.png"
                    alt=""
                    class="rating-img" />
            }
            @case (6) {
                <img
                    src="assets/images/blank.png"
                    alt=""
                    class="rating-img" />
            }
            @case (8) {
                <img
                    src="assets/images/big_stop_sign.png"
                    alt=""
                    class="rating-img" />
            }
            @case (50) {
                <img
                    src="assets/images/frown.png"
                    alt=""
                    class="rating-img" />
            }
            @case (60) {
                <img
                    src="assets/images/poop.png"
                    alt=""
                    class="rating-img" />
            }
            @case (70) {
                <img
                    src="assets/images/double_poop.png"
                    alt=""
                    class="rating-img" />
            }
            @default {
                <img
                    src="assets/images/blank.png"
                    alt=""
                    class="rating-img" />
            }
        }

        <ng-container>
            @if (dataItem.hspClass === 'Aya Priority' || dataItem.ratingId === 2 || dataItem.ratingId === 3) {
                <img
                    src="assets/images/hart.png"
                    class="rating-img"
                    alt="Aya Priority"
                    title="Aya Priority" />
            }
            @if (dataItem.hspClass === 'Aya MSP' || dataItem.ratingId === 1) {
                <img
                    src="assets/images/doublehart.png"
                    class="rating-img-double"
                    alt="Aya MSP"
                    title="Aya MSP" />
            }
        </ng-container>
    `,
    styles: [
        '.rating-img { height: auto; width: 16px !important;}',
        '.rating-img-double { height: auto; width: 32px !important;}'
    ]
})
export class JobRatingComponent {
    @Input() dataItem: any;
    qualivis_vms = QUALIVIS_VMS;
}
